import { createContext, useContext, useState, useEffect } from 'react';

// Cria o contexto
const DarkModeContext = createContext();

// Provider - envolve toda a app
export function DarkModeProvider({ children }) {
  const [mode, setMode] = useState(() => localStorage.getItem('theme-mode') || 'light');

  useEffect(() => {
    localStorage.setItem('theme-mode', mode);
  }, [mode]);

  const toggleMode = () => {
    setMode((prev) => (prev === 'light' ? 'dark' : 'light'));
  };

  return (
    <DarkModeContext.Provider value={{ mode, toggleMode }}>
      {children}
    </DarkModeContext.Provider>
  );
}

// Hook - usa o contexto compartilhado
export const useDarkMode = () => {
  const context = useContext(DarkModeContext);
  if (!context) {
    throw new Error('useDarkMode deve ser usado dentro do DarkModeProvider');
  }
  return context;
};